<template>
  <div
    id="outer"
    ref="outer"
    :class="{'fixed': stuck, 'show-mobile-menu': showMobileMenu, 'pad-banner': padForBanner}"
  >
    <div id="inner">
      <div
        id="left"
        class="flex-vertical"
      >
        <p>BIAS FX 2</p>
        <div class="vl" />
        <a>电脑版</a>
        <div class="mobile-menu">
          <span
            v-if="!showMobileMenu"
            class="menu menu-open"
            @click="showMobileMenu = true"
          />
          <span
            v-else
            class="menu menu-close"
            @click="showMobileMenu = false"
          />
        </div>
      </div>
      <div class="right right-mobile flex-vertical">
        <button
          class="invert"
          style="width:5rem"
          @click="$router.push('/download')"
        >
          下载文件
        </button>
        <button @click="goToBuyNow">
          购买
        </button>
      </div>
      <div class="right flex-vertical">
        <router-link to="/bias-fx2">
          概述
        </router-link>
        <router-link to="/bias-fx2/feature">
          特性
        </router-link>
        <router-link to="/bias-fx2/spec">
          规格
        </router-link>
        <a href="https://help.positivegrid.com/hc/en-us/categories/360002013472-BIAS-FX-2-%E7%AE%80%E4%BD%93%E4%B8%AD%E6%96%87%E7%89%88">帮助中心</a>
      </div>
    </div>
    <div
      v-if="showMobileMenu"
      class="mobile-menu-extend"
    >
      <hr>
      <span @click="showMobileMenu = false">
        <router-link to="/bias-fx2">概述</router-link>
        <router-link to="/bias-fx2/feature">特性</router-link>
        <router-link to="/bias-fx2/spec">规格</router-link>
        <a href="https://help.positivegrid.com/hc/en-us/categories/360002013472-BIAS-FX-2-%E7%AE%80%E4%BD%93%E4%B8%AD%E6%96%87%E7%89%88">帮助中心</a>
      </span>
    </div>
    <hr v-if="!stuck">
  </div>
</template>

<script>
import BiasFxBanner from '@/components/bias-banner'

export default {
  components: {
  },
  mixins: [BiasFxBanner],
  data () {
    return {
      stuck: false,
      showMobileMenu: false,
      padForBanner: true,
      prevScroll: 0
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    goToBuyNow () {
      // if (this.$route.name !== 'BiasFx2') {
      this.$router.push('/bias-fx2/#buy')
      // } else {
      window.document.querySelector('#buy').scrollIntoView()
      // }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/bias-fx2-banner.vue